"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarSourceApi = void 0;
exports.calendarSourceApi = (http, prefix = '/calendar_source') => ({
    getByPropertyId(propertyId, type) {
        return http.get(`${prefix}/property/${propertyId}${type ? `/type/${type}` : ''}?with_activity=true`);
    },
    create(propertyId, calendarSource) {
        return http.post(`${prefix}/property/${propertyId}`, calendarSource);
    },
    delete(propertyId, calendarSourceId) {
        return http.delete(`${prefix}/property/${propertyId}/id/${calendarSourceId}`);
    },
});
//# sourceMappingURL=index.js.map